import styled from 'styled-components/macro';

export const DataList = styled.div`
  flex-grow: 1;
  background-color: ${({ theme }) => theme.dark};
  padding: 20px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 29px;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;
